<template>
  <v-card flat>
    <v-card-title>
      <h3 class="headline mb-0 admin-header">Collector Logs</h3>
      <v-btn text icon color="grey lighten-1" @click="refresh" :loading="loadingCollectors || loading">
        <v-icon>fas fa-sync</v-icon></v-btn>
      <v-select :items="allCollectors" v-model="selectedCollectorId"
      item-text="id" item-value="id" label="Source Collector"
      ></v-select>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="fal fa-search"
        placeholder="Search"
        single-line
        hide-details
        clearable
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :items="filteredLogs()"
      :search="search"
      :loading="loading"
      :headers="headers"
      :footer-props="{'items-per-page-options': numRowsPerPage }"
      :options.sync="pagination"
      class="elevation-1"
    >
      <template v-slot:item.dateTime="{item}">
        <td>{{ formatDateTime(item.dateTime) }}</td>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
export default {
  props: {
    filter: String,
    numRowsPerPage: {
      type: Array,
      default: () => [5, 10, 25]
    },
    rowsPerPage: {
      type: Number,
      default: 10
    }
  },
  async created () {
    this.loading = true
    await this.$store.dispatch('collectors/getLogs', this.filter)
    this.loading = false
  },
  computed: {
    ...mapGetters('collectors', {
        collectorlogs: 'getLogs',
        allCollectors: 'getCollectors'
    })
  },
  data() {
    return {
      loading: false,
      loadingCollectors: false,
      search: '',
      pagination : {'sortBy': ['dateTime'], 'sortDesc': [true], 'rowsPerPage': this.rowsPerPage},
      headers: [
        // {text: 'id', align: 'left', sortable: false, value: 'id'},
        {text: 'DateTime', align: 'left', sortable: true, value: 'dateTime'},
        {text: 'Collector', align: 'left', sortable: true, value: 'collector'},
        // {text: 'PID', align: 'left', sortable: true, value: 'pid'},
        // {text: 'SourceType', align: 'left', sortable: true, value: 'srcType'},
        {text: 'Source', align: 'left', sortable: true, value: 'src'},
        {text: 'LogType', align: 'left', sortable: true, value: 'logType'},
        {text: 'LogSource', align: 'left', sortable: true, value: 'logSrc'},
        {text: 'Log', align: 'left', sortable: false, value: 'log'}
        ],
        fileheaders: [
          {text: 'Name', align: 'left', sortable: true, value: 'name'},
          {text: 'Size', align: 'left', sortable: true, value: 'size'},
          {text: 'Last Modified', align: 'left', sortable: true, value: 'lastModified'},
          {text: 'Collector', align: 'left', sortable: true, value: 'collector'}
        ],
      selectedCollectorId: null
    }
  },
  watch: {
    orgContext: async function(val) {
      if (!val) {
        return;
      }
      this.loadingCollectors = true
      await this.$store.dispatch('collectors/getCollectors')
      this.loadingCollectors = false
      this.refresh()
    }
  },
  methods: {
    async refresh() {
      this.loading = true
      await this.$store.dispatch('collectors/getLogs', this.filter)
      this.loading = false
    },
    formatDateTime(val) {
      return moment(val).isValid() ? moment(val).format('MM/DD/YYYY, h:mm:ss a') : val
    },
    filteredLogs() {
      if (!this.selectedCollectorId) {
        return this.collectorlogs
      }
      return _.filter(this.collectorlogs, {collector: this.selectedCollectorId})
    }
  }
}
</script>
